import React from "react"
import { ChildSelector } from "../../helpers/ChildSelector"
import Countdown from "./Countdown"
import * as countdownSectionStyles from "../../styles/landing_pages/CountdownSection.module.css"

const DEFAULT_LOCATION = `sydney`
const SUPPORTED_LOCATIONS = [
  `london`,
  `melbourne`,
  `sydney`,
  `paris`,
  `melbourne2`,
  `perth`,
]

export default function CountdownSection(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    "countdown-title",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const description = ChildSelector.select(
    content,
    "countdown-description",
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const location = getLocation(props.className || ``)
  return (
    <div className={`row ${props.className} ${countdownSectionStyles.wrapper}`}>
      <div className={`col ${countdownSectionStyles.titleSection}`}>
        <h2
          className="display-4 fw-bold mb-3"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        {description && (
          <p className={countdownSectionStyles.description}>{description}</p>
        )}
      </div>

      <div className={`col-md-4 ${countdownSectionStyles.countdownWrapper}`}>
        {location === `sydney` && (
          <Countdown targetDate="2025-05-14T09:00:00" />
        )}
        {location === `london` && (
          <Countdown targetDate="2025-04-24T09:00:00" />
        )}
        {location === `melbourne` && (
          <Countdown targetDate="2025-05-20T09:00:00" />
        )}
        {location === `melbourne2` && (
          <Countdown targetDate="2025-08-17T22:00:00" />
        )}
        {location === `paris` && <Countdown targetDate="2025-05-21T09:00:00" />}
        {location === `benelux` && (
          <Countdown targetDate="2025-05-08T09:00:00" />
        )}
        {location === `perth` && (
          <Countdown targetDate="2025-09-09T22:00:00" />
        )}
      </div>
    </div>
  )
}

const getLocation = tag => {
  let location = DEFAULT_LOCATION
  const locations = tag.split(` `).filter(cn => cn.startsWith(`icw-evt`))
  if (locations.length > 0) {
    location = locations[0].replace(`icw-evt-`, ``).toLowerCase()
    if (!SUPPORTED_LOCATIONS.includes(location)) location = DEFAULT_LOCATION
  }

  return location
}
